<template>
    <v-container>
        <v-flex class="select-topics">
            <h4>{{SpeakerConstants.SELECT_TOPIC_TOPICS}} </h4>
            <v-flex pb-3>
                <v-expansion-panel expand>
                    <v-expansion-panel-content v-for="(topic,i) in topicsList" :key="i">
                        <template v-slot:header>
                            <SpeakerTopicHeader :topic="topic"></SpeakerTopicHeader>
                        </template>
                        <SpeakerTopics :topic="topic" :topicChanged="topicChanged"></SpeakerTopics>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-flex>
        </v-flex>
    </v-container>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import SpeakerTopics from "../Speakers/SpeakerTopics";
    import { SpeakerApplicants } from "../Speakers/speakerConstant";
    import SpeakerTopicHeader from "../Speakers/SpeakerTopicHeader.vue";

    export default {
        name: "SearchSpeakers_Topics",

        data: () => ({
            SpeakerConstants: SpeakerApplicants,
        }),
        props: {
            applySpeakerFilter: {
                type: Function,
                required: true,
            },
        },
        components: {
            SpeakerTopics,
            SpeakerTopicHeader,
        },
        created() {
            this.getTopicsList(this.$route.query.topics && this.$route.query.topics.length ? this.$route.query.topics.split('~') : []);
            this.checkSpeakerTopicFilters();
        },
        methods: {
            ...mapActions({
                getTopicsList: `searchSpeaker/${storeAction.getTopicsList}`,
            }),
            ...mapMutations({
                setSelectedTopics: `searchSpeaker/${storeMutation.setSelectedTopics}`,
            }),
            topicChanged() {
                const filters = [];
                this.topicsList.forEach((topic) => {
                    topic.selectedTopics.forEach((selectedTopic) => {
                        filters.push(selectedTopic.topicName);
                    });
                });
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        topics: filters.join('~'),
                    },
                });
            },
            checkSpeakerTopicFilters() {
                let value = this.$route.query.topics;
                if (value && value.length) {
                    value = value.split('~');
                    this.setSelectedTopics(value);
                    this.applySpeakerFilter(value.map(item => ({
                        label: 'Topics',
                        filterKey: 'Topics',
                        filterValue: item,
                    })));
                }
            },
        },
        computed: {
            ...mapGetters({
                topicsList: `searchSpeaker/${storeGetters.topicsList}`,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";
</style>
